import { render } from "./StarsRating.vue?vue&type=template&id=7efc4237"
import script from "./StarsRating.vue?vue&type=script&lang=js"
export * from "./StarsRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__